module.exports = __webpack_public_path__ + "static/media/cilikba bulat.77f60593.png";